import { type FC } from 'react';
import Lock from '@assets/img/icons/lock.svg?react';

import { StringSmall } from '@/components/Typography/Typography';
import { Picture } from '@/components/ui/Picture/Picture';

interface SpecContractBenefitProps {
  icon: {
    img: string;
    webp: string;
    alt: string;
  };
  additionalText?: string;
  description: string;
}

const SpecContractBenefit: FC<SpecContractBenefitProps> = ({
  icon,
  additionalText,
  description,
}) => {
  return (
    <div className="flex items-center justify-between bg-white/10 rounded-lg py-1 pl-2 pr-4">
      <div className="flex items-center gap-2">
        <Picture className="w-8 h-8" {...icon} />
        <StringSmall>
          {additionalText && (
            <span className="text-yellow-300 mr-1">{additionalText}</span>
          )}
          <span className="text-white">{description}</span>
        </StringSmall>
      </div>
      <Lock className="size-4 min-w-4 text-white/40" />
    </div>
  );
};

export { SpecContractBenefit };
